import { MapPin, Clock, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
export default function LocalAreaOrleans() {
  return <section data-section-id="261165" id="local-area-orleans" className="bg-background py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div className="flex flex-col gap-6 lg:pr-8">
            <div className="flex flex-col items-start gap-4">
              <Badge variant="secondary" className="text-sm px-3 py-1 bg-secondary text-secondary-foreground rounded-md">
                Orleans, Ontario
              </Badge>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground tracking-tight">
                Local expertise. <br className="hidden sm:block" />
                <span className="text-primary">Right here in your community.</span>
              </h2>
            </div>

            <p className="text-lg text-muted-foreground leading-relaxed font-default">
              From the quiet streets of Orleans Village to the growing hubs of Avalon and Fallingbrook, we provide dedicated support for local businesses. We understand the unique landscape of East Ottawa, serving professional offices and retail centers across the region.
            </p>

            <div className="bg-accent/50 p-6 rounded-lg border border-border mt-2 shadow-sm">
              <h3 className="text-xl font-semibold font-default text-foreground mb-3 flex items-center gap-2">
                <MapPin className="size-5 text-primary shrink-0" />
                The East Ottawa Commitment
              </h3>
              <p className="text-foreground/80 leading-relaxed font-default">
                We don't just work remotely; we live and breathe the local area. Our service radius is focused on Orleans, Gloucester, and Barrhaven to ensure we can be on-site within hours. When your operations face a hurdle, we arrive in person to solve it.
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-4 mt-4">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:opacity-90 rounded-md shadow-md">
                <Link to="/AboutPage">Talk to us</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-primary text-primary hover:bg-accent rounded-md">
                <Link to="/PricingPage">View Pricing</Link>
              </Button>
            </div>

            <div className="flex flex-wrap items-center gap-6 text-sm font-medium text-muted-foreground mt-6 pt-6 border-t border-border">
              <Link to="/AboutPage" className="hover:text-primary transition-colors flex items-center gap-1.5">
                Where We Serve <ArrowRight className="size-3.5" />
              </Link>
              <Link to="/AboutPage" className="hover:text-primary transition-colors flex items-center gap-1.5">
                Who We Serve <ArrowRight className="size-3.5" />
              </Link>
            </div>
          </div>

          {}
          <div className="relative mt-8 lg:mt-0">
            <div className="relative rounded-lg overflow-hidden shadow-xl border border-border bg-muted">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/orleans_village_community_hub.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/orleans_village_community_hub.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/orleans_village_community_hub.png-wvc-sizes" alt="Orleans Ontario Business District" className="w-full h-auto object-cover aspect-[4/3] sm:aspect-[16/10] lg:aspect-[4/3]" loading="lazy" />
              {}
              <div className="absolute inset-0 bg-primary/10 mix-blend-multiply pointer-events-none"></div>
            </div>

            {}
            <Card className="absolute -bottom-6 left-4 sm:-bottom-8 sm:-left-8 w-[calc(100%-2rem)] sm:w-72 shadow-2xl border-border bg-card z-10 rounded-lg">
              <CardContent className="p-5 sm:p-6 flex flex-col gap-3">
                <div className="size-10 rounded-md bg-secondary/20 flex items-center justify-center text-primary mb-1">
                  <Clock className="size-5" />
                </div>
                <h4 className="font-bold font-default text-foreground text-lg">Rapid Response</h4>
                <p className="text-sm text-muted-foreground leading-snug font-default">
                  On-site assistance for critical needs across Orleans, South Keys, and surrounding areas.
                </p>
              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}